var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"wb-header-logo",attrs:{"href":"./index.html"}},[_c('img',{staticClass:"logo-pic",attrs:{"src":_vm.logoPic}})])
}
var staticRenderFns = []

export { render, staticRenderFns }